var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.unpaid?.length)?_c('div',{staticClass:"pa-3 s-vstack"},[_c('div',{staticClass:"title red--text text-center"},[_vm._v("You have unpaid invoices.")]),_c('Payment'),_c('InvoiceList',{attrs:{"items":_vm.unpaid}})],1):_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }